<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>汇率配置</el-breadcrumb-item>
          <el-breadcrumb-item>汇率配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>

          <el-col :span="14" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="insert">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          v-loading="isLoading" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="currency" :index="indexMethod" sortable align="center" label="币种">
            <template v-slot="scope">
              {{typeShow(scope.row.currency)}}
            </template>
          </el-table-column>
          <el-table-column prop="exchangeRate" label="汇率">
          </el-table-column>
          <el-table-column prop="effectiveTime" sortable align="center" :index="indexMethod" label="生效时间">
            <template v-slot="scope">
              {{ scope.row.effectiveTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable :index="indexMethod" width="100" align="center" label="创建时间">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <el-dialog :title="dialogTitle" :visible.sync="updateDialogVisible" width="30%">
      <el-form :model="exchangeRate" :rules="rules" ref="exchangeRate" label-width="110px" class="demo-exchangeRate">
        <el-form-item label="币种" prop="currency">
          <el-select v-model="exchangeRate.currency" placeholder="请选择币种">
            <el-option v-for="(item,index) in currencyTypeOptions" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇率" prop="exchangeRate">
          <el-input @input="numberInput" v-model="exchangeRate.exchangeRate" type="number" step="0.1"><template
              slot="prepend">一元=</template><template
              slot="append">{{currencyTypeOptions[exchangeRate.currency-1]?currencyTypeOptions[exchangeRate.currency-1].name:'日元' }}</template>
          </el-input>
          <el-input v-model="exchangeRate.exchangeRateCompute"><template
              slot="prepend">一{{currencyTypeOptions[exchangeRate.currency-1]?currencyTypeOptions[exchangeRate.currency-1].name:'日元' }}=</template><template
              slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="生效时间" prop="effectiveTime">
          <el-date-picker v-model="exchangeRate.effectiveTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="clearForm">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="updateSave('exchangeRate')">提 交</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  data () {
    return {
      currencyTypeOptions: [
        {
          name: '日元',
          value: '1'
        },
        {
          name: '美元',
          value: '2'
        }
      ],
      dialogTitle: '',
      isLoading: false,
      exchangeRate: {
        id: '',
        currency: '',
        exchangeRate: '',
        effectiveTime: '',
        exchangeRateCompute: '',
        delFlag: 0,
      },
      queryInfo: {
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      orderDetailValue: {
        id: '',
        rechargeStatus: ''
      },
      rules: {
        currency: [
          { required: true, message: '请选择币种', trigger: 'blur' }
        ],
        exchangeRate: [
          { required: true, message: '请输入汇率', trigger: 'blur' }
        ],
        effectiveTime: [
          { required: true, message: '请选择生效时间', trigger: 'blur' }
        ],
      },
      updateDialogVisible: false,
    }
  },
  methods: {
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    //正常发送
    sendAction (row) {
      this.sendDeal(row)
    },
    acceptAction (row) {
      this.acceptDeal(row)
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange () {

    },
    searchList () {    //查询
      console.log(this.queryInfo);
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    toRechargeMoney (row) {
      this.$router.push({
        name: 'recharge',
        query: {
          id: row.id
        }
      })
    },
    async getrecordList () {
      this.isLoading = true
      const { data: res } = await this.$http.get('/exchangeRate/list', { params: this.queryInfo });
      this.isLoading = false
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        rechargeNo: '',
        pageSize: 10,
        pageNum: 1
      }
      this.orderDateRangeValue = [];
    },
    insert (row) {     //新增
      this.dialogTitle = '新增';
      this.updateDialogVisible = true;
      this.getrecordList;
      this.exchangeRate = {
        id: '',
        currency: '1',
        exchangeRate: '',
        effectiveTime: '',
        exchangeRateCompute: '',
        delFlag: 0,
      };
    },
    updateSave (formName) {    //保存按钮
      var my = this;
      //保存按钮
      this.$refs.exchangeRate.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "/exchangeRate/saveAction";
          my.exchangeRate.effectiveTime = new Date(my.exchangeRate.effectiveTime).getTime() / 1000;
          const { data: res } = await my.$http.post(url, my.exchangeRate);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getrecordList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    clearForm () {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible = false;
    },
    initForm () {   //初始化弹窗的内容
      this.exchangeRate = {
        id: '',
        currency: '',
        exchangeRate: '',
        effectiveTime: ''
      };
    },
    numberInput (val) {
      if (val) {
        console.log(val)
        this.exchangeRate.exchangeRateCompute = 1 / val
        this.exchangeRate.exchangeRateCompute = this.exchangeRate.exchangeRateCompute.toFixed(4)
      } else {
        this.exchangeRate.exchangeRateCompute = ""
      }
    },
    typeShow (status) {
      switch (status) {
        case '1':
          return '日元'
          break;
        case '2':
          return '美元'
          break;
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }

    }
  },
  created () {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>